import { Injectable } from '@angular/core';

declare var document: any;

@Injectable({
  providedIn: 'root'
})
export class ScriptService {
  private scripts: any = {};

  constructor() {}

  loadScript(obj: {
    name: string;
    src: string;
    dataset?: Record<string, string>;
  }) {
    return new Promise((resolve, reject) => {
      if (this.scripts[obj.name]) {
        resolve(this.scripts[obj.name]);
      } else {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = obj.src;

        for (const key in obj.dataset) {
          if (Object.prototype.hasOwnProperty.call(obj.dataset, key)) {
            const value = obj.dataset[key];
            script.dataset[key] = value;
          }
        }

        this.scripts[obj.name] = { ...obj, loaded: false };
        script.onload = () => {
          this.scripts[obj.name].loaded = true;
          resolve({ ...obj, loaded: true });
        };
        script.onerror = (error: any) => {
          delete this.scripts[obj.name];
          reject({ ...obj, loaded: false });
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
